import { makeAutoObservable } from "mobx";
import { apiDelete, apiGet, apiPostPut } from "../api/api_methods";
import {
  getDomainForWhiteLabeling,
  getPoweredByUrlForWhiteLabeling,
} from "../services/white_label";

class MockStore {
  aptitude = [];
  mockTestId = "";
  mockTestInvitationLink = null;
  mockTestInvitationClientLink = null;
  setMockId = (value) => {
    this.mockTestId = value;
  };

  setMockTestInvitationLink = (value) => {
    this.mockTestInvitationLink = value;
  };
  setMockTestInvitationClientLink = (value) => {
    this.mockTestInvitationClientLink = value;
  };
  loader = false;
  question = {};
  reasonong = [];
  report = {};
  verbals = [];
  core = [];
  navigate = true;
  setNavigate(value) {
    this.navigate = value;
  }
  allow = false;
  questionNumber = "1";
  section = "APTITUDE";
  correctAnswer = 0;
  wrongAnswer = 0;
  Answer = {
    APTITUDE: [],
    REASONING: [],
    VERBAL: [],
    CORE: [],
    EEE: [],
    ECE: [],
    CIVIL: [],
    CSE: [],
    IT: [],
  };
  id = null;
  count = 0;
  testOnLive = false;
  Submit = false;
  applicants = {};
  setId(val) {
    this.id = val;
  }
  setAllow(value) {
    this.allow = value;
  }
  setApplicants(val) {
    this.applicants = val;
  }
  setSubmit(val) {
    this.Submit = val;
  }
  setLoader(val) {
    this.loader = val;
  }
  setTestOnLive(val) {
    this.testOnLive = val;
  }
  currentQuestionNumber = 1;
  setCurrentQues(val) {
    this.currentQuestionNumber = val;
    console.log("currentQuestionNumber", val);
  }
  setAnswer() {
    this.Answer[this.section].push(this.questionNumber);
    this.Answer[this.section] = Array.from(new Set(this.Answer[this.section]));
    console.log("answer", this.Answer);
    this.count = Object.values(this.Answer).reduce(
      (sum, arr) => sum + arr.length,
      0
    );
    console.log("count", this.count);
    if (
      this.question[this.section][this.questionNumber - 1].userAns ===
      this.question[this.section][this.questionNumber - 1].answer
    ) {
      this.correctAnswer++;
    } else {
      this.wrongAnswer++;
    }
    console.log("count", this.count);
    console.log("correctAnswer", this.correctAnswer);
    console.log("wrongAnswer", this.wrongAnswer);
  }
  setSection(val) {
    this.section = val;
  }
  setQuestionNumber(val) {
    this.questionNumber = val;
  }
  setQuestion() {
    this.question = {
      APTITUDE: this.aptitude,
      REASONING: this.reasonong,
      VERBAL: this.verbals,
      CORE: this.core,
    };
    console.log("hello in store", this.question);
    // this.aptitude = JSON.parse(val).APTITUDE;
    // this.reasonong = JSON.parse(val).REASONING;
    // this.verbals = JSON.parse(val).VERBAL;
  }
  setAptitude(val) {
    this.aptitude = val;
  }
  getMcqs = async (branch, que, aptitude, reasoning, tech, verbal) => {
    const response = await apiGet(
      `/mcq/get-mcqs-by-branch?branch=${branch}&number=${que}&aptitude=${aptitude}&reasoning=${reasoning}&tech=${tech}&verbal=${verbal}`
    );
    if (response.status === 200) {
      this.question = {};
      this.Answer = {
        APTITUDE: [],
        REASONING: [],
        VERBAL: [],
        CORE: [],
        EEE: [],
        ECE: [],
        CIVIL: [],
        CSE: [],
        IT: [],
      };
      this.count = 0;
      this.aptitude = [];
      this.reasonong = [];
      this.verbals = [];
      this.core = [];
      this.correctAnswer = 0;
      localStorage.setItem("que", response?.body?.data?.length);
      response.body.data.map((item, index) => {
        if (item.category === "Aptitude") {
          this.aptitude.push(item);
        } else if (item.category === "Reasoning") {
          this.reasonong.push(item);
        } else if (item.category === "Verbal") {
          this.verbals.push(item);
        } else {
          this.core.push(item);
        }
      });
      return response;
    }
  };

  getMcqsWithSameQuestion = async (userId, MockTestId) => {
    const response = await apiGet(
      `/mcq/get-mcqs-with-same-question/${MockTestId}?userId=${userId}`
    );
    if (response.status === 200) {
      this.question = {};
      this.Answer = {
        APTITUDE: [],
        REASONING: [],
        VERBAL: [],
        CORE: [],
        EEE: [],
        ECE: [],
        CIVIL: [],
        CSE: [],
        IT: [],
      };
      this.count = 0;
      this.aptitude = [];
      this.reasonong = [];
      this.verbals = [];
      this.core = [];
      this.correctAnswer = 0;
      localStorage.setItem("que", response?.body?.data?.length);
      response.body.data.map((item, index) => {
        if (item.category === "Aptitude") {
          this.aptitude.push(item);
        } else if (item.category === "Reasoning") {
          this.reasonong.push(item);
        } else if (item.category === "Verbal") {
          this.verbals.push(item);
        } else {
          this.core.push(item);
        }
      });
      return response;
    }
    console.log(response);
  };

  getAnswer = async (applicationId, invitationId, recruiterId) => {
    this.loader = true;
    const nullQuetions = [];
    const mcq = [];

    // Process answers for each category
    let noOfAptitudeQuestions = 0;
    let noOfReasoningQuestions = 0;
    let noOfVerbalQuestions = 0;
    let noOfTechnicalQuestions = 0;
    let noOfAptitudeQuestionsAnswered = 0;
    let noOfReasoningQuestionsAnswered = 0;
    let noOfVerbalQuestionsAnswered = 0;
    let noOfTechnicalQuestionsAnswered = 0;

    this.question.APTITUDE.map((item, index) => {
      noOfAptitudeQuestions++;
      if (item.userAns) {
        mcq.push({ mcq: item._id, selectedOption: item.userAns });
        noOfAptitudeQuestionsAnswered++;
      } else {
        mcq.push({ mcq: item._id, selectedOption: null });
        nullQuetions.push({
          nullQuetions: item.id,
          selectedOption: null,
          number: item.key,
        });
      }
    });

    this.question.REASONING.map((item, index) => {
      noOfReasoningQuestions++;
      if (item.userAns) {
        mcq.push({ mcq: item._id, selectedOption: item.userAns });
        noOfReasoningQuestionsAnswered++;
      } else {
        mcq.push({ mcq: item._id, selectedOption: null });
        nullQuetions.push({
          nullQuetions: item.id,
          selectedOption: null,
          number: item.key,
        });
      }
    });

    this.question.VERBAL.map((item, index) => {
      noOfVerbalQuestions++;
      if (item.userAns) {
        mcq.push({ mcq: item._id, selectedOption: item.userAns });
        noOfVerbalQuestionsAnswered++;
      } else {
        mcq.push({ mcq: item._id, selectedOption: null });
        nullQuetions.push({
          nullQuetions: item.id,
          selectedOption: null,
          number: item.key,
        });
      }
    });

    this.question.CORE.map((item, index) => {
      noOfTechnicalQuestions++;
      if (item.userAns) {
        mcq.push({ mcq: item._id, selectedOption: item.userAns });
        noOfTechnicalQuestionsAnswered++;
      } else {
        mcq.push({ mcq: item._id, selectedOption: null });
        nullQuetions.push({
          nullQuetions: item.id,
          selectedOption: null,
          number: item.key,
        });
      }
    });

    console.log(mcq);
    console.log(nullQuetions, "Null Questions");

    // If there are unanswered questions, show confirmation prompt
    if (nullQuetions.length > 0 && nullQuetions < mcq) {
      // const confirmSubmit = window.confirm(`You have not answered ${nullQuetions.length} questions. Are you ready to submit?`);
      // if (!confirmSubmit) {
      //   this.loader = false;
      //   this.setNavigate(false);
      //   return; // Stop the submission if the user is not ready
      // }
    }
    this.setNavigate(true);

    // If the user is ready, proceed with API call
    const userid = JSON.parse(localStorage.getItem("user"))?._id;
    const data = {
      candidate: userid,
      mockTestName: localStorage.getItem("branch"),
      mcqs: mcq,
      invitationId: invitationId,
      recruiterId: recruiterId,
      applicationId: applicationId,
    };

    // Call the API to submit answers
    const response = await apiPostPut(
      data,
      "/mock-test/create-mock-test",
      "POST"
    );
    if (response.status === 200) {
      this.loader = false;
      localStorage.setItem("mockTestId", response.body.data._id);

      // Reset question arrays after successful submission
      this.question = {};
      this.aptitude = [];
      this.reasonong = [];
      this.verbals = [];
      this.core = [];

      response.body.data.mcqs.map((item, index) => {
        if (item.mcq.category === "Aptitude") {
          this.aptitude.push({ ...item.mcq, userAns: item.selectedOption });
        } else if (item.mcq.category === "Reasoning") {
          this.reasonong.push({ ...item.mcq, userAns: item.selectedOption });
        } else if (item.mcq.category === "Verbal") {
          this.verbals.push({ ...item.mcq, userAns: item.selectedOption });
        } else {
          this.core.push({ ...item.mcq, userAns: item.selectedOption });
        }
      });

      this.setQuestion();
      console.log(response.body);
    } else {
      this.loader = false;
    }
  };

  createMocktestInvitation = async (
    topic,
    que,
    cutOff,
    aptitude,
    reasoning,
    verbal,
    technical,
    id,
    customSettings
  ) => {
    const userid = JSON.parse(localStorage.getItem("user"))?._id;
    const body = {
      recruiter: userid,
      mockTestName: topic,
      noOfQuestions: que,
      cutOff: cutOff,
      noOfTechnicalQuestions: Number(technical),
      noOfReasoningQuestions: Number(reasoning),
      noOfVerbalQuestions: Number(verbal),
      noOfAptitudeQuestions: Number(aptitude),
      customSettings: customSettings,
    };
    let response;
    if (id) {
      response = await apiPostPut(
        { ...body, _id: id },
        "/mock-test/update-mock-test",
        "PUT"
      );
    } else {
      response = await apiPostPut(
        body,
        "/mock-test/create-mock-test-invitation",
        "POST"
      );
    }
    if (response.status === 200) {
      console.log(response);
      this.mockTestId = response.body._id;
      this.mockTestInvitationLink = getDomainForWhiteLabeling() === "app.reaidy.io" ? `https://user.reaidy.io/mcq-test/${response.body.data._id}` : `https://${getDomainForWhiteLabeling()}/dashboard/mocktest?mocktestId=${
        response.body.data._id
      }&recruiterId=${userid}`;
      this.mockTestInvitationClientLink = `https://${getDomainForWhiteLabeling()}/share/mcq-applicants?mocktestId=${
        response.body.data._id
      }`;
      this.setTestOnLive(false);
      this.setQuestionNumber(1);
      this.setSection("APTITUDE");
      // navigate("/mock-answer");
      this.setAllow(true);
      // alert(this.allow)
      return true;
    } else if (response.status === 400) {
      this.setAllow(false);
      alert(
        response.body.message ===
          "You have reached the limit of applying mocktests. Please upgrade your plan to apply for more mocktests."
          ? "You have reached the limit of posting mocktests. Please upgrade your plan to post for more mocktests."
          : response.body.message
      );
      return false;
    } else {
      this.setAllow(false);
      return false;
    }
  };

  deleteMocktest = async (id) => {
    const response = await apiPostPut(
      { id: id },
      "/mock-test/delete-mock-test",
      "DELETE"
    );
    if (response.status === 200) {
      return true;
    } else {
      return false;
    }
  };

  getReport = async (id) => {
    this.loader = true;
    const response = await apiPostPut(
      {
        mockTestId: id,
      },
      "/mock-test/get-report",
      "POST"
    );
    if (response.status === 200) {
      this.loader = false;
      console.log("report", response.body.data);
      this.report = response.body.data;
      this.setApplicants(response.body.data.labels);
      return response;
    } else {
      this.loader = false;
    }
  };

  constructor() {
    makeAutoObservable(this);
  }
}

export default MockStore;
